export const appendHSError = (fieldWrapper, errorName) => {
  const errorElement = document.createElement('li');
  const errorInput = fieldWrapper.querySelector('.hs-input');
  const newErrorList = document.createElement('ul');

  errorInput.classList.add('invalid', 'error');
  errorElement.innerHTML = `<li><label class="hs-error-msg hs-main-font-element">${errorName}</label></li>`;

  newErrorList.classList.add('no-list', 'hs-error-msgs', 'inputs-list', 'custom-list');
  newErrorList.setAttribute('role', 'alert');
  newErrorList.appendChild(errorElement);
  fieldWrapper.appendChild(newErrorList);
};

export const removeHSCustomErrors = fieldWrapper => {
  const errorLists = fieldWrapper.querySelectorAll('.hs-error-msgs.custom-list');
  const errorInput = fieldWrapper.querySelector('.hs-input');

  errorInput.classList.remove('invalid', 'error');

  if (errorLists.length) errorLists.forEach(errorList => (errorList ? errorList.remove() : null));
};

export const removeHSErrors = fieldWrapper => {
  const errorLists = fieldWrapper.querySelectorAll('.hs-error-msgs:not(.custom-list)');
  if (errorLists.length) errorLists.forEach(errorList => (errorList ? errorList.remove() : null));
};
